if (!customElements.get('gift-card-recipient')) {
  class GiftCardRecipient extends HTMLElement {
    connectedCallback() {
      this.recipientEmail = this.querySelector('[name="properties[Recipient email]"]');
      this.recipientName = this.querySelector('[name="properties[Recipient name]"]');
      this.recipientMessage = this.querySelector('[name="properties[Message]"]');
      this.senderName = this.querySelector('[name="properties[Sender name]"]');
      this.recipientSendOn = this.querySelector('[name="properties[Send on]"]');
      this.recipientOffsetProperty = this.querySelector('[name="properties[__shopify_offset]"]');
      this.recipientCheckbox = this.querySelector('.gift-card-recipient__checkbox');

      if (!this.recipientCheckbox) return;

      // Set the timezone offset property input and enable it
      if (this.recipientOffsetProperty) {
        this.recipientOffsetProperty.value = new Date().getTimezoneOffset().toString();
        this.recipientOffsetProperty.removeAttribute('disabled');
      }

      this.recipientCheckbox.addEventListener('change', () => {
        this.synchronizeProperties();
        this.clearErrors();
      });
      this.synchronizeProperties();

      // Clear errors on input
      const inputs = this.querySelectorAll('input, textarea');
      for (const input of inputs) {
        input.addEventListener('input', () => this.clearFieldError(input));
      }
    }

    synchronizeProperties() {
      if (!this.recipientCheckbox) return;

      if (this.recipientCheckbox.checked) {
        if (this.recipientEmail) {
          this.recipientEmail.setAttribute('required', '');
          this.recipientEmail.removeAttribute('disabled');
        }
        if (this.recipientName) {
          this.recipientName.setAttribute('required', '');
          this.recipientName.removeAttribute('disabled');
        }
        if (this.recipientMessage) {
          this.recipientMessage.removeAttribute('disabled');
        }
        if (this.senderName) {
          this.senderName.setAttribute('required', '');
          this.senderName.removeAttribute('disabled');
        }
        if (this.recipientSendOn) {
          this.recipientSendOn.setAttribute('required', '');
          this.recipientSendOn.removeAttribute('disabled');
        }
        if (this.recipientOffsetProperty) {
          this.recipientOffsetProperty.removeAttribute('disabled');
        }
      } else {
        if (this.recipientEmail) {
          this.recipientEmail.removeAttribute('required');
          this.recipientEmail.setAttribute('disabled', '');
        }
        if (this.recipientName) {
          this.recipientName.setAttribute('disabled', '');
        }
        if (this.senderName) {
          this.senderName.setAttribute('disabled', '');
        }
        if (this.recipientMessage) {
          this.recipientMessage.setAttribute('disabled', '');
        }
        if (this.recipientSendOn) {
          this.recipientSendOn.setAttribute('disabled', '');
        }
        if (this.recipientOffsetProperty) {
          this.recipientOffsetProperty.setAttribute('disabled', '');
        }
      }
    }

    clearErrors() {
      const errorElements = this.querySelectorAll('.gift-card-recipient__error');
      for (const errorElement of errorElements) {
        errorElement.hidden = true;
        errorElement.textContent = '';
      }

      const inputElements = this.querySelectorAll('.gift-card-recipient__input--error');
      for (const inputElement of inputElements) {
        inputElement.classList.remove('gift-card-recipient__input--error');
        inputElement.removeAttribute('aria-invalid');
      }
    }

    clearFieldError(input) {
      const fieldMap = {
        'properties[Recipient email]': 'email',
        'properties[Recipient name]': 'name',
        'properties[Message]': 'message',
        'properties[Sender name]': 'sender',
        'properties[Send on]': 'send-on'
      };

      const fieldName = fieldMap[input.name];
      if (fieldName) {
        const errorElement = this.querySelector(`[data-field="${fieldName}"].gift-card-recipient__error`);
        if (errorElement) {
          errorElement.hidden = true;
          errorElement.textContent = '';
        }
        input.classList.remove('gift-card-recipient__input--error');
        input.removeAttribute('aria-invalid');
      }
    }
  }

  customElements.define('gift-card-recipient', GiftCardRecipient);
}
